import loadable from "@loadable/component";
import React from "react";
import { Brand } from "types/common";

const GlobalThemeComponent =
  process.env.NODE_ENV === "production"
    ? () => null
    : loadable(() => import("@tvg/fuse-design/themes"), { resolveComponent: (m) => m.GlobalThemeComponent });

const FuseBrandMap = {
  [Brand.Very]: Brand.Very,
  [Brand.VeryIE]: Brand.Very,
  [Brand.Littlewoods]: Brand.Littlewoods,
  default: "default",
} as const;

export default function GlobalTheme({ brand = "default" }: { brand?: keyof typeof FuseBrandMap }) {
  return <GlobalThemeComponent brand={FuseBrandMap[brand]} />;
}
